export default "__VITE_ASSET__k7e0xko9__"